(function(run) {
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})(function() {
  const sectionEl = document.getElementById('lg-recently-viewed-section');
  const gridEl = document.getElementById('lg-recently-viewed-grid');
  if (!sectionEl || !gridEl) return;

  const currentHandle = sectionEl.dataset.productHandle;
  if (!currentHandle) return;

  const STORAGE_KEY = 'lg-recently-viewed';
  let list = [];
  try {
    list = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  } catch (e) {}

  // Filter out current handle and limit to 4 items for a clean grid display
  const handlesToRender = list.filter(h => h !== currentHandle).slice(0, 4);

  // Prepend current product handle for future visits
  list = list.filter(h => h !== currentHandle);
  list.unshift(currentHandle);
  if (list.length > 8) {
    list = list.slice(0, 8);
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(list));

  // If no other products viewed, do not show the section
  if (handlesToRender.length === 0) return;

  // Escape para interpolar datos de producto dentro de innerHTML
  const esc = window.lgEscapeHtml || function(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  };

  // Fetch product JSON details from Shopify API
  async function loadRecentlyViewed() {
    try {
      const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || (window.routes && window.routes.cart_url ? window.routes.cart_url.replace(/cart$/, '') : '/');
      const fetchPromises = handlesToRender.map(handle =>
        fetch(`${rootUrl}products/${handle}.js`)
          .then(res => {
            if (!res.ok) throw new Error('Product not found');
            return res.json();
          })
          .catch(err => null) // Ignore failed fetches
      );

      const products = (await Promise.all(fetchPromises)).filter(p => p !== null);
      if (products.length === 0) return;

      sectionEl.style.display = 'block';
      gridEl.innerHTML = '';

      products.forEach(prod => {
        // Find compare_at_price if any
        let hasSale = prod.compare_at_price > prod.price;
        let discountHtml = '';
        if (hasSale) {
          let savings = Math.round((prod.compare_at_price - prod.price) * 100 / prod.compare_at_price);
          discountHtml = `<span class="badge color-accent" style="margin-left: 5px; background: var(--lg-gold-gradient, #F8900B); color: white; border: none; padding: 2px 8px; border-radius: 20px; font-weight: bold; font-size: 1.2rem;">-${savings}% DTO.</span>`;
        }

        // Format prices (in EUR)
        const formatEur = (cents) => new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(cents / 100);
        const priceFormatted = formatEur(prod.price);
        const compareFormatted = hasSale ? formatEur(prod.compare_at_price) : '';

        // Grid item card
        const cardCol = document.createElement('div');
        cardCol.className = 'grid__item slider__slide';
        cardCol.style.cssText = 'position: relative; display: flex; flex-direction: column; background: rgb(var(--color-background)); border: 1px solid rgba(var(--color-foreground), 0.05); border-radius: 12px; overflow: hidden; transition: all 0.3s ease; box-shadow: 0 4px 12px rgba(0,0,0,0.02);';

        cardCol.innerHTML = `
          <div style="position: relative; width: 100%; aspect-ratio: 1; overflow: hidden; background: rgba(var(--color-foreground), 0.02);">
            <a href="${esc(prod.url)}" style="display: block; width: 100%; height: 100%;">
              <img src="${esc(prod.featured_image) || 'data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'%23F8900B\'><circle cx=\'12\' cy=\'12\' r=\'10\'/></svg>'}" alt="${esc(prod.title)}" style="width: 100%; height: 100%; object-fit: cover; transition: transform 0.5s ease;" onmouseover="this.style.transform='scale(1.05)'" onmouseout="this.style.transform='scale(1)'" loading="lazy">
            </a>
            <button type="button" class="lg-wishlist-card-btn lg-wishlist-btn-toggle" data-id="${prod.id}" data-handle="${esc(prod.handle)}" data-title="${esc(prod.title)}" data-image="${esc(prod.featured_image)}" data-price="${esc(priceFormatted)}" data-url="${esc(prod.url)}" aria-label="Favoritos" style="position: absolute; top: 12px; right: 12px; z-index: 10;">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="width: 18px; height: 18px;"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
            </button>
            <button type="button" class="lg-compare-card-btn lg-compare-btn-toggle" data-id="${prod.id}" data-handle="${esc(prod.handle)}" data-title="${esc(prod.title)}" data-image="${esc(prod.featured_image)}" aria-label="Comparar" style="position: absolute; top: 54px; right: 12px; z-index: 10;">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" style="width: 16px; height: 16px;"><rect x="3" y="3" width="7" height="18" rx="1"/><rect x="14" y="3" width="7" height="18" rx="1"/><path d="M6 9h1M17 9h1M6 13h1M17 13h1"/></svg>
            </button>
          </div>
          <div style="padding: 1.25rem; flex-grow: 1; display: flex; flex-direction: column; justify-content: space-between; gap: 8px;">
            <div>
              <h3 style="font-size: 1.3rem; font-weight: 600; margin: 0; line-height: 1.35; font-family: var(--font-body-family); color: rgb(var(--color-foreground));">
                <a href="${esc(prod.url)}" style="text-decoration: none; color: inherit; transition: color 0.2s;" onmouseover="this.style.color='var(--lg-gold)'" onmouseout="this.style.color='inherit'">${esc(prod.title)}</a>
              </h3>
            </div>
            <div style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
              <span style="font-weight: 600; font-size: 1.5rem; color: rgb(var(--color-foreground));">${priceFormatted}</span>
              ${hasSale ? `<span style="text-decoration: line-through; font-size: 1.3rem; color: rgba(var(--color-foreground), 0.4);">${compareFormatted}</span>` : ''}
              ${discountHtml}
            </div>
          </div>
        `;

        gridEl.appendChild(cardCol);
      });

      // Trigger updates for state (like wishlist active heart state on loaded cards)
      if (window.dispatchEvent) {
        window.dispatchEvent(new Event('lg:wishlist:updated'));
        window.dispatchEvent(new Event('lg:compare:updated'));
      }

    } catch (error) {
      console.log('Error rendering recently viewed products:', error);
    }
  }

  loadRecentlyViewed();
});
